export default "__VITE_ASSET__2Im$pzfr__"